import { useMemo } from 'react';

import styled from '@emotion/styled';
import { Grid } from '@kc-console/common-ui';

import type { MultiSectionItemWithValue } from './types';

interface DetailMultiViewContentProps {
  sections: MultiSectionItemWithValue[];
  selectedTab: MultiSectionItemWithValue['value'];
}

const DetailMultiViewContent = ({ sections, selectedTab }: DetailMultiViewContentProps) => {
  const selectedSection = useMemo(
    () => sections.find(section => section.value === selectedTab),
    [sections, selectedTab],
  );

  // 탭은 존재하고 탭 내용이 없는 경우
  if (selectedSection?.emptyState) {
    return <EmptyStateContainer>{selectedSection.emptyState}</EmptyStateContainer>;
  }

  return <DetailMultiViewContentRoot>{selectedSection?.content}</DetailMultiViewContentRoot>;
};

const DetailMultiViewContentRoot = styled(Grid)``;

const EmptyStateContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 100%;
`;

export default DetailMultiViewContent;
